const body = document.body;
const WIDTH = 992 // refer to Bootstrap's responsive design

export default {
    data() {
        return {
            is_mobile: false,
        }
    },
    beforeMount() {
        window.addEventListener('resize', this.$_resizeHandler)
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.$_resizeHandler)
    },
    mounted() {
        const isMobile = this.$_isMobile()
        this.is_mobile = isMobile;
    },
    methods: {
        $_isMobile() {
            const rect = body.getBoundingClientRect()
            return rect.width - 1 < WIDTH
        },
        $_resizeHandler() {
            const isMobile = this.$_isMobile()
            this.is_mobile = isMobile;
        }
    },
}
